import {
  AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, Input, OnChanges, OnInit,
  PLATFORM_ID,
  SimpleChanges,
  Inject,
} from '@angular/core';
// import {Work} from '../../models/work';
// import {WorksService} from '../../services/works.service';
import {ActivatedRoute, ParamMap, Params} from '@angular/router';
import {isPlatformServer, Location} from '@angular/common';

import 'rxjs/add/operator/switchMap';
import {ScrollPositionService} from '../../services/scroll-position.service';
import {Project} from '../../models/project';
import {KenticoService} from '../../services/kentico.service';
import {ContentItem} from 'kentico-cloud-delivery-typescript-sdk';

@Component({
  selector: 'app-work-detail',
  templateUrl: './work-detail.component.html',
  styleUrls: ['./work-detail.component.css'],
})
export class WorkDetailComponent implements OnInit, AfterViewInit {
  slug: string;
  project: Project;
  // @Input() work: Work;
  // works: Work[] = [];
  projects: Project[];
  // nextWork: Work;
  // previousWork: Work;
  newerProject: Project;
  olderProject: Project;
  inComponent = false;
  checked = false;

  constructor(private spService: ScrollPositionService,
              // private worksService: WorksService,
              private kenticoService: KenticoService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      return this.kenticoService.getProject(params.get('slug'));
    }).subscribe(project => {
      this.project = project;
      this.kenticoService.getNewerProject(project).subscribe(newerProject => this.newerProject = newerProject);
      this.kenticoService.getOlderProject(project).subscribe(olderProject => {
        this.olderProject = olderProject;
      });
      if (this.inComponent) {
        this.spService.autoScroll();
      }
    });
  }

  scrollToTop(): void {
    this.spService.scrollToTop();
  }

  ngAfterViewInit() {
    console.log('AfterViewInit');
    this.spService.autoScroll();
    this.inComponent = true;
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/work-detail/work-detail.component.ts